import classnames from 'classnames';

import "./styles.scss"

type Props = {
    activeSubtab: "leaders" | "my_place";
    labels: Record<string, string>;
    onChange: (sub: "leaders" | "my_place") => void;
    className?: string
};

export const PPDWidgetLeagueRatingSubTabs = ({ activeSubtab, labels, onChange, className }: Props) => {
    return (
        <nav className={classnames("ppd-widget-league-rating-subtabs", className)}>
            {(["leaders", "my_place"] as const).map((sub) => (
                <button
                    key={sub}
                    className={classnames("ppd-widget-league-rating-subtabs__item", {
                        "ppd-widget-league-rating-subtabs__item--active": activeSubtab === sub,
                    })}
                    onClick={() => onChange(sub)}
                >
                    {labels[sub]}
                </button>
            ))}
        </nav>
    );
};
